import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LCLShipmentModel } from '@data-layer/models/lcl';
import { DateTimezoneService } from '@services/date-timezone.service';
import { enumLclTrackingStates } from '@enum/enumLclTrackingStates';
import { TranslateService } from '@ngx-translate/core';
import { enumShippingRole } from '@data-layer/enums/user';

@Component({
  selector: 'app-lcl-origin-warehouse',
  templateUrl: './lcl-origin-warehouse.component.html',
  styleUrls: ['./lcl-origin-warehouse.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LclOriginWarehouseComponent {
  @Input() public shipment: LCLShipmentModel;
  public TRACKING_STATES: typeof enumLclTrackingStates = enumLclTrackingStates;

  constructor(private dateService: DateTimezoneService, private translateService: TranslateService) {}

  public getDifferenceDays(): string {
    const daysBetween: number = this.daysBetween;

    return daysBetween > 0
      ? this.translateService.instant('LABELS.ORIGIN_WAREHOUSE_CUTOFF_DAYS_LEFT', { daysCount: daysBetween })
      : this.translateService.instant('LABELS.ORIGIN_WAREHOUSE_CUTOFF_DAYS_MISSED');
  }

  public get daysBetween(): number {
    return this.dateService.daysBetween(new Date().toString(), this.shipment.voyage.warehouseCutoff);
  }

  public get isImporter(): boolean {
    return this.shipment.shippingRole === enumShippingRole.IMPORTER;
  }
}
